import { classNames } from "@circle-react/helpers/twMergeWithCN";
import Linkify from "linkify-react";
import type { ReactNode } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import { messageTextClasses } from "./messageTextClasses";

const linkifyOptions = {
  rel: "noopener noreferrer",
  target: "_blank",
};

export interface PlainMessageBodyProps {
  body: ReactNode;
}

export const PlainMessageBody = ({ body }: PlainMessageBodyProps) => (
  <div
    className={classNames(
      anchorClassNames("chat-message-word-wrap"),
      messageTextClasses,
    )}
    data-testid="message-text"
  >
    <Linkify options={linkifyOptions}>{body}</Linkify>
  </div>
);
